var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSendRaiOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.558 6.838C2.828 4.855 4.901 3 6.792 3.945l19.937 9.968c1.72.86 1.72 3.314 0 4.174L6.792 28.056C4.9 29 2.828 27.144 3.558 25.16L6.933 16 3.558 6.838zm2.339-1.105a.333.333 0 00-.461.414L8.698 15h3.635a1 1 0 010 2H8.698l-3.262 8.853a.334.334 0 00.461.414l19.938-9.97a.333.333 0 000-.595L5.896 5.732z",
    fill: "#3D3D3D"
  })));
}

export default SvgIconSendRaiOutline;